import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/relojchecador/incidencia-validacion/';
/**
 * GET Incidencia Validacion
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasValidacionesPag = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Incidencia Validacion
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasValidaciones = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Incidencia Validacion
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getIncidenciaValidacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Incidencia Validacion
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postIncidenciaValidacion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Incidencia Validacion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchIncidenciaValidacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Incidencia Validacion
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteIncidenciaValidacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Incidencia Validacion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarIncidenciaValidacion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
